/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/body/body_styles';
import { createStyles, heights, spacing, pxToEm } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ BODY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Body extends Component {
	constructor(props) {
		super(props);
	}
	getInlineStyles = () => {
        const globalEls = this.props.currentContentSettings.elements;
        const hasRewardsComponent = this.props.rewardsEnabled && this.props.rewardsPermitted;
        const padding = {
            top: globalEls.header ? heights.header : 0,
            left: spacing.sides,
            bottom:  globalEls.footer ? `${(parseFloat(this.getFooterHeight(hasRewardsComponent), 10) + parseFloat(this.getRewardsIndicatorHeight(hasRewardsComponent), 10))}em` : 0,
            right: spacing.sides
        };
        return {
            'padding-top': padding.top,
            'padding-left': padding.left,
            'padding-right': padding.right,
            'padding-bottom': padding.bottom
        };
    };
    getFooterHeight = hasRewardsComponent => hasRewardsComponent ? pxToEm(25) : pxToEm(35); // 40
    getRewardsIndicatorHeight = hasRewardsComponent => hasRewardsComponent ? pxToEm(70) : '0em'; // 74 // only set a height if rewards are enabled
	render() {
        return (
	        <div className={`${sheet.classes.body} body`} style={this.getInlineStyles()}>
	        	{this.props.markup}
	        </div>
    	);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Body;
